import { TestCaseValues } from './types';

export const TEST_CASES_INITIAL_VALUES: TestCaseValues = {
  additionalAmount: null,
  additionalBusinessUnitId: null,
  additionalDepartmentId: null,
  approvalLevelValueId: null,
  businessUnitId: null,
  comment: null,
  companyPhaseTypeId: null,
  currencyId: null,
  departmentId: null,
  elapsedDays: null,
  purchaseOrderTypeId: null,
  requesterUserProfileId: null,
  rowSecurityId: null,
  tagId: null,
  totalAmount: null,
  transactionHintId: null,
  userGroupId: null,
  userRankId: null,
  workgroupId: null,
};
